import { getCountryFromSideFilters, getProductGroupFromSideFilters } from '@utils/FilterUtils';
import { PageName, PageType } from '@utils/pageConfig/Types';
import { concatenateSelectedFeatureName, doAmplitudeAnalyticsTracking } from '../PageAnalytics';
import { AnalyticTrackingBasePropertiesObj, TrackingGeneralProp } from './AnalyticTrackingBasePropertiesObj';

//Example of tracking for - Table Clicked
/**
 analytics.track("Table Clicked", {
 "access": "Retail Insights",
 "country": "Germany",
 "elementName": "Product Group",
 "elementType": "Table Product Group",
 "optionChosen": "COOLING",
 "pageName": "Category Leaderboard",
 "productGroup": "All",
 "section": "Retail Intelligence",
 "subsection": "Products"
 "tableName": "Category Leaderboard Table"
 })
 **/

export const TABLE_CLICKED_TRACKING_TITLE = 'Table Clicked';
export const TABLE_PRODUCT_GROUP = 'Table Product Group';
export const PRODUCT_GROUP = 'Product Group';

//Extend base properties
export interface TableClickTracking extends AnalyticTrackingBasePropertiesObj {
  elementName: string;
  elementType: string;
  optionChosen: string;
  column?: string;
}

export enum TableName {
  CATEGORY_LEADERBOARD = 'Category Leaderboard Table',
  PERFORMANCE_BY_SEGMENTS = 'Performance by segments Table',
  OPPORTUNITY_REVIEW_TABLE = 'Opportunity Review for Retailer Table',
  OPPORTUNITY_REVIEW_BUBBLE_CHART = 'Opportunity Review for Retailer Bubble Chart',
  EXPLORE_LEADERBOARD_TABLE = 'Explore Leaderboard Table',
  EXPLORE_TRENDS = 'Explore Trends Line Chart',
  EXPLORE_SEGMENTS = 'Explore Segments Stack Chart',
  EXPLORE_LEADERBOARD_BAR_CHART = 'Explore Leaderboard Double Bar Chart',
}

export interface TableClickTrackingParam {
  eventTitle: string;
  sideFilters: any;
  retailerClientState: any;
  track: (event: string, properties?: Object) => void;
  pageType: PageType;
  pageName: PageName;
  componentName: string;
  elementType: string;
  optionChosen: string;
  column?: string;

  access: Object;
}

export const tableClickTrackingFunction = (param: TableClickTrackingParam) => {
  const {
    sideFilters,
    pageName,
    retailerClientState,
    pageType,
    componentName,
    track,
    eventTitle,
    elementType,
    optionChosen,
    column,
    access,
  } = param;

  const selectedSideFilter = sideFilters[pageType];

  const appliedProductGroup = getProductGroupFromSideFilters(selectedSideFilter);
  const appliedFiltersCountry = getCountryFromSideFilters(selectedSideFilter);

  const tableClickTrackingProperties: TableClickTracking = {
    access: access,
    locationId: appliedFiltersCountry?.options.map((options) => options.label),
    itemGroup: concatenateSelectedFeatureName(appliedProductGroup),
    pageName: pageName,
    retailerDataFor: retailerClientState.clientName,
    section: TrackingGeneralProp.SECTION_TRACKING_PROP,
    subsection: pageName,
    elementName: componentName,
    elementType: elementType,
    optionChosen: optionChosen,
    column: column,
  };

  doAmplitudeAnalyticsTracking(eventTitle, track, tableClickTrackingProperties);
};
